<template>
    <div style="display: flex; flex-direction: column;">
        <div :style="{color: passwordHint === '' || password === null || password === '' ? '#d9d9d9' : ''}" style="width: 60px; height: 50px; display: flex; justify-content: center; align-items: center; font-weight: 700; margin-left: auto;" @click="savePrivateInfo">저장</div>
        <div style="flex: 1; padding: 0 20px;">
            <div style="text-align: center; margin-top: 30px;">
                <div style="font-weight: 700; font-size: 32px; margin-bottom: 16px;">비공개 멤버톡</div>
                <div style="font-weight: 500; line-height: 23px;">비공개 멤버톡은 매니저의 초대 혹은<br>입장 코드 입력을 통해 참여할 수 있습니다.<br>멤버톡의 암호 설정이 필요합니다.</div>
            </div>
            <div style="margin-top: 40px;">
                <div style="margin-bottom: 40px;">
                    <div class="title">상태</div>
                    <div style="text-align: center;" class="common_box">
                        <img style="width: 13px;" :src="require('@/assets/img/private.png')" alt="">
                        <span style="display: inline-block;margin-left: 8px; font-weight: 700; font-size: 14px; line-height: 20px;">비공개</span>
                    </div>
                    <div style="font-weight: 500; color: #606060; margin-top: 4px; font-size: 12px; line-height: 17px;">멤버톡의 참여 형태는 멤버톡 설정탭에서 언제든 변경할 수 있습니다.</div>
                </div>

                <div style="margin-bottom: 32px;">
                    <div class="title">멤버톡 입장 코드 힌트를 입력해주세요</div>
                    <input v-model="passwordHint" placeholder="예 : 맨체스터 시티 구단의 창단 년도" class="common_input" type="text">
                </div>
                <div style="margin-bottom: 32px;">
                    <div class="title">암호를 설정해주세요</div>
                    <input v-model="password" placeholder="숫자만 입력 가능" class="common_input" type="tel">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponseCode from '../../../ResponseCode'

    export default {
        name: 'PrivateMemberTalk',
        props: {
            memberTalkIdx: {
                type: [String, Number],
                default: -1
            }
        },
        data() {
            return {
                passwordHint: '',
                password: null
            }
        },
        methods: {
            async savePrivateInfo() {
                if (this.passwordHint === '' || this.password === null || this.password === '') {
                    return
                }

                const formData = new FormData()
                formData.append('mode', 'update')
                formData.append('join_idx', this.memberTalkIdx)
                formData.append('password_hint', this.passwordHint)
                formData.append('password', this.password)

                const res = await this.$Axios.post('/api/join/save', formData)

                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal()
                    this.$GlobalStore.addModal('MemberTalkDetailSetting', {memberTalkIdx: this.memberTalkIdx})
                } else {
                    console.log(res.data.msg)
                }

            }
        },
        created(){
            this.savePrivateInfo = this.$Once(this.savePrivateInfo)
        }
    }
</script>

<style scoped>
.common_box {
    border-radius: 12px;
    background-color: #f5f5f5;
    padding: 12px;
}

.title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
}

.common_input {
    padding: 10px;
    padding-left: 12px;
    border: none;
    width: 100%;
    border-radius: 12px;
    background-color: #f5f5f5;
    outline: none;
}

.common_input::placeholder {
    color: #bbbbbb;
    font-weight: 700;
    font-size: 14px;
}
</style>